<script setup lang="ts">
import { useStayStore } from '../stores/stayStore';
import TopBar from '../components/TopBar.vue';
import LoginForm from '../components/auth/LoginForm.vue';
import { format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';

const store = useStayStore();

async function handleLogin() {
  await store.authenticate(store.bookingNumber, store.lastName);
}

function formatDate(dateStr: string): string {
  return format(parseISO(dateStr), 'dd. MMMM yyyy', { locale: de });
}
</script>

<template>
  <div>
    <TopBar />
    <div class="stay-container">
      <template v-if="!store.token">
        <LoginForm @submit="handleLogin" />
      </template>
      <template v-else>
        <div class="stays-list">
          <div v-if="store.isLoading" class="loading">
            Lädt Aufenthalte...
          </div>
          <div v-else-if="store.error" class="error">
            {{ store.error }}
          </div>
          <template v-else>
            <div v-for="stay in store.stays" :key="stay.from_date" class="stay-item">
              <div class="stay-dates">
                {{ formatDate(stay.from_date) }} - {{ formatDate(stay.until_date) }}
              </div>
              <div class="stay-kind">{{ stay.kind }}</div>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.stay-container {
  padding: 1rem;
  margin-top: 48px;
  margin-bottom: 48px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.stays-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.loading {
  text-align: center;
  color: #666;
  padding: 1rem;
}

.error {
  color: #dc2626;
  margin-top: 1rem;
  text-align: center;
}

.stay-item {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.stay-dates {
  color: #960040;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.stay-kind {
  color: #666;
}
</style>